var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6947 6.86316C10.3368 6.50526 9.68421 6.50526 9.32632 6.86316L5.53684 10.6526C5.1579 11.0316 5.1579 11.6421 5.53684 12.0211C5.91579 12.4 6.52632 12.4 6.90526 12.0211L10 8.92632L13.0947 12.0211C13.2842 12.2105 13.5368 12.3158 13.7895 12.3158C14.0421 12.3158 14.2947 12.2105 14.4842 12.0211C14.8632 11.6421 14.8632 11.0316 14.4842 10.6526L10.6947 6.86316Z",
    fill: "#939393"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.48421 0 0 4.48421 0 10C0 15.5158 4.48421 20 10 20C15.5158 20 20 15.5158 20 10C20 4.48421 15.5158 0 10 0ZM10 18.0632C5.55789 18.0632 1.93684 14.4421 1.93684 10C1.93684 5.55789 5.55789 1.93684 10 1.93684C14.4421 1.93684 18.0632 5.55789 18.0632 10C18.0632 14.4421 14.4421 18.0632 10 18.0632Z",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.16597e51595232054bc0d8f3a9961558.svg";
export { ForwardRef as ReactComponent };